import Vue from "vue";
import Router from "vue-router";
import home from "../view/home";
import homeM from "../view/home_m";
import CaseM from "../view/case_m";
import AboutM from "../view/about_m";
import ProductM from "../view/product_m";
import CaseViewM from "../view/caseView_m.vue";
import Case from "../view/case";
import About from "../view/about";
import Product from "../view/product";
import ProDetail from "../view/proDetail";
import News from "../view/news";
import NewsView from "../view/newsView";
import CaseView from "../view/caseView.vue";
import indexPC from "../view/index_pc";
import indexM from "../view/index_m";
Vue.use(Router);
const redirectPath = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
  navigator.userAgent
)
  ? "index_m"
  : "index_pc";
export default new Router({
  mode: "history",
  routes: [
    // { path: "/", redirect: "/home" },
    { path: "/", redirect: redirectPath },
    {
      path: "/index_pc",
      name: "index_pc",
      meta: { type: "pc" },
      component: indexPC,
      redirect: "/index_pc/home",
      children: [
        {
          path: "/index_pc/home",
          name: "home",
          component: home,
          meta: { type: "pc" },
        },
        {
          path: "/index_pc/about",
          name: "about",
          component: About,
          meta: { type: "pc" },
        },
        {
          path: "/index_pc/product",
          name: "product",
          component: Product,
          meta: { type: "pc" },
        },
        {
          path: "/index_pc/proDetail",
          name: "proDetail",
          component: ProDetail,
          meta: { type: "pc" },
        },
        {
          path: "/index_pc/case",
          name: "case",
          component: Case,
          meta: { type: "pc" },
        },
        {
          path: "/index_pc/news",
          name: "news",
          component: News,
          meta: { type: "pc" },
        },
        {
          path: "/index_pc/newsView",
          name: "newsView",
          component: NewsView,
          meta: { type: "pc" },
        },
        {
          path: "/index_pc/caseView",
          name: "caseView",
          component: CaseView,
          meta: { type: "pc" },
        },
      ],
    },
    {
      path: "/index_m",
      name: "index_m",
      meta: { type: "mobile" },
      component: indexM,
      redirect: "/index_m/home_m",
      children: [
        {
          path: "/index_m/home_m",
          name: "home_m",
          component: homeM,
          meta: { type: "mobile" },
        },
        {
          path: "/index_m/about_m",
          name: "about_m",
          component: AboutM,
          meta: { type: "mobile" },
        },
        {
          path: "/index_m/product_m",
          name: "product_m",
          component: ProductM,
          meta: { type: "mobile" },
        },
        {
          path: "/index_m/case_m",
          name: "case_m",
          component: CaseM,
          meta: { type: "mobile" },
        },
        {
          path: "/index_m/caseView_m",
          name: "caseView_m",
          component: CaseViewM,
          meta: { type: "mobile" },
        },
      ],
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js